// File: utils/checkoutTableUtils.js

/**
 * Resolve a dot-notated path against an object.
 * e.g. getByPath(data, "customer.name")
 */
export const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
};

/**
 * Format a raw value according to the `format` specified in the JSON config.
 * Keep all display formatting centralized here so components / config
 * stay declarative.
 */
export const formatValue = (value, format) => {
  if (value === null || value === undefined || value === "") return "-";

  switch (format) {
    case "currency":
      return `₹${Number(value).toFixed(2)}`;

    case "percent":
      return `${Number(value)}%`;

    case "datetime":
      return new Date(value).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });

    case "date":
      return new Date(value).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });

    default:
      return value;
  }
};

/**
 * Render a "count × rate = amount" string for extra bed/person/child rows.
 * e.g. formatExtraCharge(2, 5) -> "2 × ₹5.00 = ₹10.00"
 * Returns "-" when there's nothing extra (count is 0/empty).
 */
export const formatExtraCharge = (count, rate) => {
  const c = Number(count || 0);
  const r = Number(rate || 0);
  if (c <= 0) return "-";
  return ` ₹${r.toFixed(2)} × ${c}  = ₹${(c * r).toFixed(2)}`;
};